module.exports = "./img/741e8cbb7399836f8adac1bde889c170.jpg";